import type { FormInstance } from "antd";
import { useTranslation } from "react-i18next";
import { CustomTypography } from "sipli-fleet-core/components";
import CustomerFormField from "../CustomerFormField";
import type { CustomerSelectLookups } from "../CustomerTabs";

const AdditionalInformation = ({
  form: _form,
  selectLookups,
}: {
  form: FormInstance;
  selectLookups: CustomerSelectLookups;
}) => {
  const { t } = useTranslation();

  return (
    <div className="mb-8">
      <CustomTypography.CustomTitle className="!text-[17.72px] !font-bold">
        {t("additional_info")}
      </CustomTypography.CustomTitle>

      <div className="mt-7">
        {/* <CustomerFormField
          name="legalName"
          label={t("legal_name")}
          className="!h-[32px] !rounded-[4px]"
          placeholder={t("type")}
        /> */}
        <CustomerFormField
          name="businessType"
          label={t("type_of_business")}
          className="!h-[32px] !rounded-[4px]"
          placeholder={t("type")}
          disabled
        />
        <div className="grid grid-cols-2 gap-x-3">
          <CustomerFormField name="regNo" className="!h-[32px] !rounded-[4px]" label={t("registration_no")} placeholder={t("type")} disabled />
          <CustomerFormField name="address" className="!h-[32px] !rounded-[4px]" label={t("address")} placeholder={t("type")} disabled />
          <CustomerFormField name="billAddress" className="!h-[32px] !rounded-[4px]" label={t("bill_address")} placeholder={t("type")} disabled />
          <CustomerFormField
            name="handlingInPlace"
            className="!h-[32px] !rounded-[4px]"
            label={t("handling_in_place")}
            placeholder={t("type")}
            disabled
          />
          <CustomerFormField name="vatNr" className="!h-[32px] !rounded-[4px]" label={t("vat_nr")} placeholder={t("type")} disabled />
          <CustomerFormField name="bank" className="!h-[32px] !rounded-[4px]" label={t("bank")} placeholder={t("type")} disabled />
          <CustomerFormField name="accountNo" className="!h-[32px] !rounded-[4px]" label={t("account_no")} placeholder={t("type")} disabled />
          <CustomerFormField name="swift" className="!h-[32px] !rounded-[4px]" label={t("swift")} placeholder={t("type")} disabled />
        </div>

        <div className="p-4 mt-6 bg-gray1">
          <CustomTypography.CustomText className="!mb-4 !block !text-[15.75px] !font-[600] !text-gray9">
            {t("marketing_info")}
          </CustomTypography.CustomText>
          <div className="grid grid-cols-2 gap-x-3">
            <CustomerFormField
              name="source"
              label={t("source")}
              placeholder={t("select")}
              className="!h-[32px] !rounded-[4px]"
              options={selectLookups.clientSourceOptions}
              loading={selectLookups.clientSourceLoading}
            />
            <CustomerFormField
              name="competitor"
              label={t("competitors")}
              placeholder={t("select")}
              className="!h-[32px] !rounded-[4px]"
              options={selectLookups.clientCompetitorOptions}
              loading={selectLookups.clientCompetitorLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalInformation;
